function Vacancies() {
  return (
    <>
    <div className="service-title text-green-38B652 font-700 mb-3">VACANCIES</div>
    <div className="service-box mb-5 mb-sm-4">The South African Maritime Safety Authority (SAMSA) was established on the 1st of April 1998 under the SAMSAAct 5 of 1998.</div>

    <div className="row g-3 g-sm-4">
        <div className="col-12">
            <div className="row g-3">
                {/* <div className="col-lg-7"><p className="font-17 text-primary-color"><b>Mid - Senior UX/UI Designer</b>  <span className="text-orange-ef3e33">(REMOTE</span> CLOSING DATE 23/01/2025<span className="text-orange-ef3e33">)</span></p></div>
                <div className="col-12"><p className="font-17 text-primary-color"><span className="d-block">ENVIRONMENT:</span>
                A leading health and wellness platform dedicated to empowering  individuals to achieve their health goals through accessible, effective  care, ..........</p></div>
                */}
                <div className="col-auto"><a className="btn-green-38B652 text-decoration-none" target="_blank" href="https://samsajobs.mcidirecthire.com/Vacancy">View All Vacancies </a></div> 
                <div className="col-auto"><a className="btn-green-38B652 text-decoration-none" target="_blank" href="https://samsajobs.mcidirecthire.com/Account/Login">Returning Applicants</a></div>
            </div>
        </div>
    </div>
    </>
  )
}

export default Vacancies;